import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { css } from 'styled-components/macro';
import { themeUi } from '../../themeUi/themeUi';
import { shared } from './shared';

const tableTheme = shared.table;
const paginationTheme = tableTheme.components.tablePagination;

export const main: ThemeApp['appComponents']['main'] = {
  mainContainer: {
    props: css`
      //old table
      div:has(> div[role='table']) {
        background-color: ${tableTheme.table.container.backgroundColor};
        box-shadow: ${tableTheme.table.container.boxShadow};

        & div[role='table'] {
          background-color: ${tableTheme.table.container.backgroundColor};

          & div[role='columnheader'] {
            color: ${tableTheme.table.th.color};
            background: none;

            & > div {
              border-right: solid 1px ${themeUi.semantic.color.border.secondary800};
              padding-right: 0.5rem;
              height: 4rem;
            }
            &:last-child {
              & > div {
                border-right: none;
              }
            }
          }
          & div[role='rowgroup'] {
            border-color: ${themeUi.semantic.color.border.secondary800};

            &[data-role='table-body'] {
              & div[role='row'] {
                border-color: ${themeUi.semantic.color.border.secondary800};

                & div[role='cell'] * {
                  color: ${themeUi.semantic.color.text.secondary200};
                }
              }
            }

            &[data-role='table-footer'] {
              div[role='row'] div[role='cell'] {
                > div {
                  border-color: ${themeUi.semantic.color.border.secondary800};
                }

                div span {
                  color: ${paginationTheme.textContainer.enabledColor};
                }

                button span {
                  color: ${paginationTheme.textContainer.enabledColor};
                }

                button {
                  &:not([disabled]) {
                    color: ${paginationTheme.textContainer.enabledColor};
                  }
                  &:disabled {
                    color: ${paginationTheme.textContainer.disabledColor};
                  }
                }
              }
            }
          }
        }
      }

      // subscription overview
      section:has(span[data-testid='plan-card-main-container']) {
        div[data-role='listitem'] {
          box-shadow: ${themeUi.semantic.color.border.secondary800} 0px 0px 0px 1px;
        }
      }
    `
  },

  bodyContainer: {
    bodyBackgroundColor: themeUi.semantic.color.background.secondary990
  },

  globalAlertBanner: {
    iconColor: themeUi.semantic.color.text.secondary50
  },

  hooks: {
    useInitializedStripe: {
      stripeElementsOptions: {
        colorText: themeUi.semantic.color.text.secondary200,
        colorTextPlaceholder: themeUi.semantic.color.text.secondary700,
        borderColor: themeUi.semantic.color.text.secondary700,
        fontFamily: themeUi.core.font.fontFamily.regular,
        backgroundColor: themeUi.semantic.color.background.secondary950,
        borderColorFocused: themeUi.semantic.color.text.primary300,
        borderColorDisabled: themeUi.semantic.color.text.secondary700
      }
    }
  }
};
